import { render, staticRenderFns } from "./Scale_configuration.vue?vue&type=template&id=3b5aa0a8&style=height%3A100%25"
import script from "./Scale_configuration.vue?vue&type=script&lang=js"
export * from "./Scale_configuration.vue?vue&type=script&lang=js"
import style0 from "./Scale_configuration.vue?vue&type=style&index=0&id=3b5aa0a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports